import script from "./UserAgreementView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserAgreementView.vue?vue&type=script&setup=true&lang=ts"

import "./UserAgreementView.vue?vue&type=style&index=0&id=4611892f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4611892f"]])

export default __exports__